import { invoke } from 'wecom-sidebar-jssdk'

/** 群聊版允许的打开入口：工具栏 / 附件栏 */
export const QYWX_GROUP_VALID_ENTRIES = ['group_chat_tools', 'chat_attachment']

/**
 * sendChatMessage 的 enterChat：附件栏下 true 会在发送成功后跳回会话并关闭 H5 面板
 * @returns {boolean}
 */
export function getSendChatEnterChat() {
	const entry = localStorage.getItem('qywxEntry') || ''
	return entry !== 'chat_attachment'
}

/**
 * 初始化群聊/附件栏上下文：校验 entry、隐藏附件栏默认发送按钮、可选记录群 ID
 * @param {Vue} vm
 * @returns {Promise<string>} entry
 */
export async function setupQywxGroupContext(vm) {
	try {
		const res = await invoke('getContext')
		const entry = res.entry || res.entryType || ''
		if (entry) {
			localStorage.setItem('qywxEntry', entry)
		}
		if (entry && !QYWX_GROUP_VALID_ENTRIES.includes(entry)) {
			vm.$message({
				message: '请从企业微信会话的群聊工具栏或聊天附件栏打开本页面',
				type: 'warning',
				duration: 5000
			})
			return entry
		}
		if (entry === 'chat_attachment') {
			await hideAttachmentSendButton()
		}
		if (entry === 'group_chat_tools') {
			await trySaveGroupChatId()
		}
		return entry
	} catch (e) {
		console.log('getContext:', e.message)
		return ''
	}
}

/** 附件栏场景隐藏底部「发送」按钮，改由页面内「发送/生成订单」调用 sendChatMessage */
async function hideAttachmentSendButton() {
	try {
		await invoke('hideChatAttachmentMenu', { menuList: ['sendMessage'] })
	} catch (e) {
		console.log('hideChatAttachmentMenu:', e.message)
	}
}

async function trySaveGroupChatId() {
	try {
		const res = await invoke('getCurExternalChat')
		if (res.err_msg === 'getCurExternalChat:ok' && res.chatId) {
			localStorage.setItem('qywxChatId', res.chatId)
		}
	} catch (e) {
		console.log('getCurExternalChat:', e.message)
	}
}
